import React from "react";
import FunnelInsightCard from "./FunnelInsightCard";
import { buildChannelRealOrdersChart } from "./funnelChartUtils";
import {
  cleanLines,
  extractTitle,
  stripTitleLines,
  extractTableBlock,
  splitByHeading,
  toBullets,
  toParagraphs,
  extractVerdict,
} from "./funnelUtils";

const FunnelChannelRealOrders = ({ markdown = "" }) => {
  const title = extractTitle(markdown) || "Which Channel Brings Real Orders";
  const lines = stripTitleLines(cleanLines(markdown));
  const { table, before, after } = extractTableBlock(lines);
  const chart = buildChannelRealOrdersChart(table);
  const { tail } = splitByHeading(after, "What Does This Mean?");

  const preBullets = toBullets(before);
  const preParagraphs = preBullets.length ? [] : toParagraphs(before);
  const bullets = toBullets(tail);
  let paragraphs = toParagraphs(tail);
  const verdict = extractVerdict(paragraphs);
  if (verdict) paragraphs = paragraphs.slice(0, -1);

  const sections = [];
  if (preBullets.length || preParagraphs.length) {
    sections.push({
      title: "Signal Summary",
      bullets: preBullets,
      paragraphs: preParagraphs,
    });
  }
  sections.push({
    title: "Channel Performance Table",
    chart,
    chartTitle: "Channel Comparison",
    chartSubtitle:
      "Horizontal grouped bars make it way easier to compare channels without squinting at the table.",
    table,
    paragraphs: [],
  });
  sections.push({
    title: "What Does This Mean?",
    bullets,
    paragraphs,
    verdict,
  });

  return (
    <FunnelInsightCard title={title} kicker="Channel Performance" sections={sections} />
  );
};

export default FunnelChannelRealOrders;
